module.exports = __webpack_public_path__ + "img/ic_file_download.539db3ce.svg";